






import '../../../public/style/joint.css';
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as joint from 'jointjs';
import { shapes, dia } from 'jointjs';
import $ from 'jquery';
import * as _ from 'lodash';
import { JointShapeRepository } from '@/libs/com/MetaPattern/MDA/Designer/Repository/JointShapeRepository';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { Diagram } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Diagram';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { Product } from '@/api/com/MetaPattern/MDA/MD/Base/Product';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { ShapeElement } from '@/api/com/MetaPattern/MDA/Designer/Shape/ShapeElement';
import { BaseLink, BaseLinkView } from '@/libs/com/MetaPattern/MDA/Designer/BaseShape/BaseLink';
import { RelationshipLink } from '@/libs/com/MetaPattern/MDA/Designer/BaseShape/RelationshipLink';
import { Stack } from '@/libs/com/MetaPattern/Product/IDE/Util/Stack';
import { EnumComponentType, EnumComponentTypeMD } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { MDRepository } from '@/libs/com/MetaPattern/MDA/MD/MDRepository';
import { PartShape } from '@/libs/com/MetaPattern/MDA/Designer/BaseShape/PartShape';
import { JointCommentShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointCommentShape';
import { JointEntityShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointEntityShape';
import { JointBusinessLogicShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointBusinessLogicShape';
import { JointConfigGroupShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointConfigGroupShape';
import { JointConstantShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointConstantShape';
import { JointDistributedTransactionShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointDistributedTransactionShape';
import { JointDTOShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointDTOShape';
import { JointEnumShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointEnumShape';
import { JointExternalServiceShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointExternalServiceShape';
import { JointInterfaceShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointInterfaceShape';
import { JointMenuSetShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointMenuSetShape';
import { JointServiceShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointServiceShape';
import { JointAggregationLink } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Link/JointAggregationLink';
import { JointAssociationLink } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Link/JointAssociationLink';
import { JointCompositionLink } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Link/JointCompositionLink';
import { JointCrossLink } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Link/JointCrossLink';
import { JointDependencyAssociationLink } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Link/JointDependencyAssociationLink';
import { JointGenerationLink } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Link/JointGenerationLink';
import { JointImplementLink } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Link/JointImplementLink';
import { JointMenuContainLink } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Link/JointMenuContainLink';
import { ContextMenu } from '@/libs/com/MetaPattern/MDA/Designer/BaseShape/ContextMenu';
import { MDShape } from '@/libs/com/MetaPattern/MDA/Designer/BaseShape/MDShape';
import { GraghData } from '@/libs/com/MetaPattern/MDA/Designer/GraphData';
import { BEEntity } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { CopyContent } from '@/libs/com/MetaPattern/Product/IDE/Util/CopyContent';
import { Double2D } from '@/api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { EnumDisplayLanguage } from '@/api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { JointValueObjectShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointValueObjectShape';
import { MDShapeRepository } from '@/libs/com/MetaPattern/MDA/Designer/BaseShape/MDShapeRepository';
import { BEComponent } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { BaseShapeView, MDBaseShape } from '@/libs/com/MetaPattern/MDA/Designer/BaseShape/MDBaseShape';
import { ResizeShape, ResizeTool } from '@/libs/com/MetaPattern/MDA/Designer/BaseShape/ResizeTool';
import { InterfaceMethod } from '@/api/com/MetaPattern/MDA/MD/EntityModel/InterfaceMethod';
import { EntityMethod } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EntityMethod';
import { ValueObjectMethod } from '@/api/com/MetaPattern/MDA/MD/EntityModel/ValueObjectMethod';
import { JointMethodShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointMethodShape';
import { JointProductAPPShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointProductAPPShape';
import { RectShape } from '@/libs/com/MetaPattern/MDA/Designer/BaseShape/RectShape';
import { MDAConstant } from '@/libs/com/MetaPattern/MDA/Designer/Base/MDAConstant';
import { JointReferenceEntityShape } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Shape/JointReferenceEntityShape';
import { BEServiceAction } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEServiceAction';
import { EnumServiceActionType } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EnumServiceActionType';
import { MDParameter } from '@/api/com/MetaPattern/MDA/MD/EntityModel/MDParameter';
import { ESParameter } from '@/api/com/MetaPattern/MDA/MD/EntityModel/ESParameter';
import { IDEProgram } from '@/libs/com/MetaPattern/Product/IDE/IDEProgram';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { EnumDataType } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BEDTO } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEDTO';
import { BEEnum } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEEnum';
import { MenuSet } from '@/api/com/MetaPattern/MDA/MD/APPModel/MenuSet';
import { Aggregation } from '@/api/com/MetaPattern/MDA/MD/EntityModel/Aggregation';
import { EnumEntityStructureType } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EnumEntityStructureType';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';

@Component({
  components: {}
})
/**
 * 注意点：
 * 1、每个MD元数据，要保持几个地方的同步：ModuleMD、Diagram、各个Shape的element
 */
export default class Draw extends Vue {
  @Prop() appId!: string; // 应用ID
  @Prop() productId!: string; // 产品ID
  @Prop() comId!: string;
  @Prop() designId!: string; // 当前组件的设计期ID
  @Prop() comType!: EnumComponentType;
  private curGraph: joint.dia.Graph = null;
  private curPaper: joint.dia.Paper = null;
  private curDiagram: Diagram;
  private curContextMenu: any;
  private originalGraphData: GraghData;
  private curLink: any;
  private curDisplayLanguage: EnumDisplayLanguage;
  private methodShape: JointMethodShape;

  // Undo & Reduce : Redu and Reduce
  private permitCache = true; // 是否可以缓存
  private stackReduce: Stack<GraghData> = new Stack<GraghData>(); // 每次变化压入堆栈
  private stackRedo: Stack<GraghData> = new Stack<GraghData>(); // 用于存储Ctrl+Z之后弹出的数据

  constructor() {
    super();
    this.curDiagram = null;
  }

  get drawId(): string {
    return 'panel' + this.designId;
  }

  mounted() {
    this.init();
    /** TODO <画线>: 处理方式不好，以后再说 */
    // window.addEventListener('mousemove', this.handleMove);
  }

  created() {
    EventBus.$on('pgValueChanged', (name: string, newValue: any) => {
      if (!this.isCurrentDoc()) return;
      const cell = this.$store.state.ModuleMD.curCell;
      if (cell && cell !== null) {
        const curShape = cell as MDBaseShape;
        if (curShape && curShape !== null) {
          curShape.refresh();
          // this.refreshShape(curShape);
          this.cacheGraph();
        }
      }
    });
    // 响应新建元素的事件
    EventBus.$on('addElement', (element: BaseElement) => {
      if (!this.isCurrentDoc()) return;
      if (element && element != null) {
        this.$store.dispatch('ModuleMD/setElementAction', { element: element, componentDesignId: this.curDiagram.component.designId });
        const container = this.curGraph.getCells().find((cell: dia.Cell) => {
          if (cell instanceof ResizeShape) {
            return false;
          }
          return (cell as unknown as MDShape).element().designId === element.designId;
        });
        if (container) {
          this.selectCell(container);
        }
      }
    });
    // 选中一个元数据的事件
    EventBus.$on('selectElement', (containerDesignId: string, designId: string) => {
      if (!this.isCurrentDoc()) return;
      if (this.curDiagram.component.designId === containerDesignId) {
        this.selectCell(null);
        this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', this.designId);
        this.$store.dispatch('ModuleMD/setCurCellIdAction', '');
      } else {
        const container = this.curGraph.getCells().find((cell: dia.Cell) => {
          if (cell instanceof ResizeShape) {
            return false;
          }
          return (cell as unknown as MDShape).element().designId === containerDesignId;
        });
        if (container) {
          this.selectRow(container, designId);
        }
      }
    });
    // 工具条菜单命令
    EventBus.$on('tool:command', (command: string) => {
      // console.log('tool:command - ' + command);
      let modifyCount = 0;
      this.$store.state.ModuleMD.elements.forEach((element: BaseElement) => {
        if (element.persistenceStatus !== EnumPersistenceStatus.None) {
          modifyCount++;
        }
      });
      console.log('待修改元数据：' + modifyCount);
      modifyCount = 0;
      this.$store.state.ModuleMD.diagrams.forEach((diagram: Diagram) => {
        if (diagram.diagramShape.persistenceStatus !== EnumPersistenceStatus.None) {
          modifyCount++;
        }
        diagram.shapeElements.forEach((shapeElement: ShapeElement) => {
          if (shapeElement.persistenceStatus !== EnumPersistenceStatus.None) {
            modifyCount++;
          }
        });
      });
      console.log('待修改图表数据：' + modifyCount);

      // 保存当前组件
      if (command === 'save') {
        if (this.$store.state.ModuleMD.curDiagram.component.designId === this.curDiagram.component.designId) {
          this.saveDiagram(this.$store.state.ModuleMD.curDiagram);
        }
      } else if (command === 'saveAll') {
        if (this.curDiagram.isModified) {
          this.saveDiagram(this.curDiagram);
        }
      } else if (command === 'toChinese' && this.curDisplayLanguage !== EnumDisplayLanguage.Chinese) {
        this.setPermitCache('cell:pointerdown', false);
        this.curDisplayLanguage = EnumDisplayLanguage.Chinese;
        this.curDiagram.setDisplayLanguage(this.curDisplayLanguage);
        this.setPermitCache('cell:pointerdown', true, 300);
        // this.fillGragh(this.curDiagram);
      } else if (command === 'toEnglish' && this.curDisplayLanguage !== EnumDisplayLanguage.English) {
        this.setPermitCache('cell:pointerdown', false);
        this.curDisplayLanguage = EnumDisplayLanguage.English;
        this.curDiagram.setDisplayLanguage(this.curDisplayLanguage);
        this.setPermitCache('cell:pointerdown', true, 300);
        // this.fillGragh(this.curDiagram);
      }
    });
  }

  updated() {
    // console.log('Draw : updated : ' + this.comId);
  }

  init() {
    // 先创建joint graph 对象
    this.curGraph = new joint.dia.Graph({}, { cellNamespace: joint.shapes });

    // 设定容器基本信息
    const paper = new joint.dia.Paper({
      el: document.getElementById(this.drawId),
      width: '100%',
      height: '100%',
      gridSize: 5, // 栅格点间距，元素拖动会捕捉栅格点
      drawGrid: {
        name: 'doubleMesh',
        args: [
          {
            color: '#909399', // 栅格点颜色
            scaleFactor: 1,
            thickness: 1 // 栅格点大小
          },
          {
            color: '#9da0a7', // 栅格点颜色
            scaleFactor: 10,
            thickness: 1 // 栅格点大小
          }
        ]
      },
      model: this.curGraph,
      linkPinning: false, // 连线必须连到某个元素，即不允许连到空白处,
      snapLinks: true,
      restrictTranslate: true, // 设定元素不能拖出画布
      cellViewNamespace: joint.shapes,
      elementView: BaseShapeView,
      linkView: BaseLinkView,
      validateConnection: this.validateConnection,
      interactive: () => { // TODO：禁止交互，但是这个只能针对Paper本身的元素，增加的工具、右键菜单、快捷键等，都需要进行自行处理
        if (this.curDiagram.isLock()) {
          return false;
        }
        return true;
      }
    });
    this.curPaper = paper;

    this.curDisplayLanguage = IDEContext.instance.getDisplayLanguage();
    this.methodShape = null;

    // 要考虑多种情况：
    // 1. 正常组件，包含Diagram，里面包含component
    // 2. 服务端仅有元数据，不包含Diagram，包含component
    // 3. 前端新建组件，新建的Diagram，新建的component
    if (this.designId && this.designId !== '') {
      const component = this.$store.state.ModuleMD.elements.find((element: BaseElement) => element.designId === this.designId);
      if (component.persistenceStatus !== EnumPersistenceStatus.Create) {
        const diagram = this.$store.state.ModuleMD.diagrams.find((item: Diagram) => item.component.designId === this.designId);
        if (diagram) {
          this.curDiagram = diagram;
          this.fillDiagram(this.curDiagram);
        } else {
          Diagram.loadAsync(this.designId, this.comType)
            .then((response) => {
              this.curDiagram = response;
              this.fillDiagram(this.curDiagram);
            })
            .catch(err => {
              console.log(err);
              this.$message({ type: 'error', message: '打开组件失败!原因是：' + err });
              this.$emit('OpenDocFaild', this.designId);
            });
        }
      } else {
        this.curDiagram = Diagram.create(component);
        this.fillDiagram(this.curDiagram);
      }
    } else if (this.appId && this.appId !== '') {
      const app = this.$store.state.ModuleMD.apps.find((item: APP) => item.id === this.appId);
      const component = MDRepository.createAPPComponent(app, this.comType);
      this.curDiagram = Diagram.create(component);
      this.fillDiagram(this.curDiagram);
    } else if (this.productId && this.productId !== '') {
      const product = this.$store.state.ModuleMD.products.find((item: Product) => item.id === this.productId);
      const apps = this.$store.state.ModuleMD.apps as Array<APP>;
      let sysAPP: APP;
      for (const app of apps) {
        if (app.isSystem) {
          sysAPP = app;
          break;
        }
      }
      MDRepository.createProductComponent(product, sysAPP, this.comType).then((component) => {
        this.curDiagram = Diagram.create(component);
        this.fillDiagram(this.curDiagram);
      });
    }
    this.buildPaperEvent(paper);
    this.buildGraphEvent(this.curGraph);
  }

  validateConnection(cellViewS: dia.CellView, magnetS: SVGElement, cellViewT: dia.CellView, magnetT: SVGElement, end: dia.LinkEnd, linkView: dia.LinkView): boolean {
    if (end === 'source') return false;
    let result = false;
    const link = linkView.model as RelationshipLink;
    const source = cellViewS.model as unknown as MDShape;
    const target = cellViewT.model as unknown as MDShape;
    if (source && target && link) {
      result = link.checkShapeType(source.shapeType(), target.shapeType());
    }
    return result;
  }

  beforeDestroy() {
    EventBus.$off('pgValueChanged');
    EventBus.$off('addElement');
    EventBus.$off('tool:command');
  }

  drawShape() {
    // console.log('draw end');
  }

  enter() {
    // console.log('draw enter');
  }

  over(e: any) {
    // console.log('draw over');
    e.preventDefault();
  }

  /** 拖动元素，创建新的图形及元数据，不支持线的拖拽 */
  drop(e: any) {
    // console.log('draw -> drop');
    const type = e.dataTransfer.getData('type');
    const elementId = e.dataTransfer.getData('elementId');
    if (type && type !== '') {
      const diagram = this.$store.state.ModuleMD.curDiagram;
      let jShape: any;
      if (elementId) {
        if (type === MDAConstant.Type.ADD_APP) {
          jShape = JointShapeRepository.createTypeShape(MDAConstant.Type.ADD_PRODUCTAPP, diagram, e.layerX, e.layerY);
          const productAPP = (jShape as JointProductAPPShape).productAPP;
          productAPP.aPP = this.$store.state.ModuleMD.apps.find((item: APP) => item.designId === elementId);
          if (productAPP.aPP) {
            productAPP.name = 'Product' + productAPP.aPP.name;
            productAPP.displayName = productAPP.aPP.displayName;
            productAPP.description = productAPP.aPP.description;
          }
          jShape.refresh();
        } else if (type === MDAConstant.Type.ADD_ENTITY) {
          jShape = JointShapeRepository.createTypeShape(MDAConstant.Type.ADD_REFERENCEENTITY, diagram, e.layerX, e.layerY);
          (jShape as JointReferenceEntityShape).referenceEntity.entity = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === elementId);
          jShape.refresh();
        } else if (type === MDAConstant.Type.ADD_SERVICEACTION) {
          jShape = JointShapeRepository.createTypeShape(MDAConstant.Type.ADD_EXTERNALSERVICE, diagram, e.layerX, e.layerY);
          // 并不记录外部服务ExternalService来自于哪个服务操作ServiceAction？？？
          const externalService = (jShape as JointExternalServiceShape).externalService;
          const serviceAction = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === elementId) as BEServiceAction;
          const app = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.id === serviceAction.service.component.aPP_ID) as APP;
          if (serviceAction.serviceActionType === EnumServiceActionType.BusinessLogic) {
            const businessLogic = serviceAction.businessLogic;
            externalService.returnDataType = businessLogic.returnDataType;
            // todo 如果是引用类型，应该如何处理？很难自动创建相关的引用类型。所以置空，可以提示重设返回类型
            if (externalService.returnDataType !== EnumDataType.Reference) {
              externalService.returnReferenceType = businessLogic.returnReferenceType;
            }
            externalService.name = businessLogic.name;
            externalService.displayName = businessLogic.displayName;
            externalService.returnDescription = businessLogic.returnDescription;
            externalService.description = businessLogic.description;
            externalService.returnIsCollection = businessLogic.returnIsCollection;
            externalService.returnIsPaged = businessLogic.returnIsPaged;
            externalService.serviceName = app.name;
            let actionName = serviceAction.name.toLowerCase();
            if (actionName.startsWith('bl')) {
              actionName = serviceAction.name.substring(2);
            }
            externalService.action = actionName;
            externalService.httpMethod = serviceAction.httpMethod;
            externalService.networkProtocol = serviceAction.networkProtocol;
            externalService.serviceUrl = `service/${serviceAction.service.name}`;
            externalService.enableDistributeTransaction = businessLogic.enableDistributeTransaction;
            externalService.dTPType = businessLogic.dTPType;
            businessLogic.parameters.forEach(item => {
              const parameter = MDRepository.createESParameter(externalService);
              const id = parameter.id;
              const designId = parameter.designId;
              (parameter as MDParameter).copyFrom(item as MDParameter, false);
              parameter.id = id;
              parameter.designId = designId;
              parameter.createdOn = new Date();
              parameter.persistenceStatus = EnumPersistenceStatus.Create;
              parameter.externalService = externalService;
              this.$store.dispatch('ModuleMD/setElementAction', { element: parameter, componentDesignId: this.curDiagram.component.designId });
            });
          } else {
            const ex = serviceAction.externalService;
            externalService.returnDataType = ex.returnDataType;
            // todo 如果是引用类型，应该如何处理？很难自动创建相关的引用类型。所以置空，可以提示重设返回类型
            if (externalService.returnDataType !== EnumDataType.Reference) {
              externalService.returnReferenceType = ex.returnReferenceType;
            }
            externalService.name = ex.name;
            externalService.displayName = ex.displayName;
            externalService.returnDescription = ex.returnDescription;
            externalService.description = ex.description;
            externalService.returnIsCollection = ex.returnIsCollection;
            externalService.returnIsPaged = ex.returnIsPaged;
            externalService.serviceName = app.name;
            let actionName = serviceAction.name.toLowerCase();
            if (actionName.startsWith('bl')) {
              actionName = actionName.substring(2);
            }
            externalService.action = actionName;
            externalService.httpMethod = serviceAction.httpMethod;
            externalService.networkProtocol = serviceAction.networkProtocol;
            externalService.serviceUrl = `service/${serviceAction.service.name}`;
            externalService.enableDistributeTransaction = ex.enableDistributeTransaction;
            externalService.dTPType = ex.dTPType;
            ex.parameters.forEach(item => {
              const parameter = MDRepository.createESParameter(externalService);
              const id = parameter.id;
              const designId = parameter.designId;
              parameter.copyFrom(item, false);
              parameter.id = id;
              parameter.designId = designId;
              parameter.createdOn = new Date();
              parameter.persistenceStatus = EnumPersistenceStatus.Create;
              parameter.externalService = externalService;
              this.$store.dispatch('ModuleMD/setElementAction', { element: parameter, componentDesignId: this.curDiagram.component.designId });
            });
          }
          (jShape as JointExternalServiceShape).setMD((jShape as JointExternalServiceShape).shape(), externalService, false);
          jShape.refresh();
        }
        // TODO : 还需要处理服务等
      } else {
        jShape = JointShapeRepository.createTypeShape(type, diagram, e.layerX, e.layerY);
        if (jShape instanceof JointEntityShape) {
          jShape.entity.superEntity = this.$store.state.ModuleMD.elements.find((element: BaseElement) => element.designId === IDEProgram.instance.BaseEntityDesignId);
        }
      }
      this.curGraph.addCell(jShape);
      const typeShape = jShape as MDBaseShape;
      if (typeShape) {
        typeShape.setDisplayLanguage(this.curDisplayLanguage);
        this.$store.dispatch('ModuleMD/setElementAction', { element: typeShape.element(), componentDesignId: this.curDiagram.component.designId });
      }
      this.selectCell(jShape);

      e.preventDefault();
    }
  }

  /** 图形是否发生变化 */
  isModified() {
    return this.curDiagram.isModified;
  }

  /** 图形发生变化的时候刷新图形 */
  refreshShape(cell: any) {
    // 刷新图形。
    // TODO ： 问题，在图形内部，TypeScript无法调用这个方法，why？
    if (cell !== null && cell.refresh) {
      cell.refresh();
    }
  }

  /**
   * 打开右键菜单
   * @param cellView 打开菜单的图形
   * @param evt 事件
   * @param x 鼠标横坐标
   * @param y 鼠标纵坐标
   * @param data 带入的额外数据，各个具体菜单自行处理
   */
  openContextMenu(cellView: any, evt: any, x: number, y: number, data?: any) {
    const menu = JointShapeRepository.createContextMenu(cellView === null ? null : cellView.model, evt.target, data);
    if (menu !== null) {
      menu.position(x, y);
      this.curContextMenu = menu;
      menu.addTo(this.curGraph);
    }
  }

  /** 关闭右键菜单 */
  closeContextMenu() {
    if (this.curContextMenu || this.curContextMenu != null) {
      // console.log('close context menu');
      this.curContextMenu.remove();
      this.curContextMenu = null;
    }
  }

  beginAddLink() {
    // 提前做处理
  }

  endAddLink() {
    this.curLink = null;
    // console.log('end add link');
    EventBus.$emit('endAddLink');
  }
  /** 处理VUE的鼠标移动事件，joint的无法满足 */
  /** TODO <画线>: 处理方式不好，以后再说 */
  // handleMove(evt: any) {
  //   const linkType = this.$store.state.ModuleMD.curLinkType;
  //   if (linkType !== '' && this.curLink != null) {
  //     this.curLink.target(new joint.g.Point(evt.offsetX, evt.offsetY));
  //     document.getElementById(this.drawId).style.cursor = 'not-allowed';
  //   }
  // }

  /** 给链接添加视图工具 */
  addLinkView(link: any) {
    const linkView = link.findView(this.curPaper);

    const verticesTool = new joint.linkTools.Vertices();
    const segmentsTool = new joint.linkTools.Segments();
    const boundaryTool = new joint.linkTools.Boundary();
    const targetArrowheadTool = new joint.linkTools.TargetArrowhead();
    const removeButton = new joint.linkTools.Remove({ action: this.deleteLink });
    const infoButton = new joint.linkTools.Button({ distance: 30 });

    const toolsView = new joint.dia.ToolsView({
      tools: [verticesTool, segmentsTool, boundaryTool, targetArrowheadTool, removeButton, infoButton]
    });

    linkView.addTools(toolsView);
    linkView.hideTools();
  }

  buildPaperEvent(paper: joint.dia.Paper) {
    $(paper.el).attr('tabindex', 0)
      .on('mouseenter', function() { // mouseover
        this.focus();
      })
      .on('keydown', e => {
        /** 重做、恢复的键盘事件 */
        // 只有当前文档响应快捷键
        if (!this.isCurrentDoc()) return;
        if (e.ctrlKey === true) {
          switch (e.key) {
            case 'y':
              /* Ctrl + Y 重做 */
              this.redoGraph();
              break;
            case 'z':
              /* Ctrl + Z 还原 */
              this.reduceGraph();
              break;
            case 's':
              /* Ctrl + S 保存 */
              this.saveDiagram(this.curDiagram);
              e.preventDefault();
              break;
            case 'c':
              /* Ctrl + C 复制 */
              this.copyCell();
              break;
            case 'x':
              /* Ctrl + X 剪切 */
              this.copyCell();
              this.deleteCell();
              break;
            case 'v':
              /* Ctrl + V 粘贴 */
              this.pasteCell(this.$store.state.ModuleMD.copyContents);
              break;
            default: break;
          }
        } else if (e.key === 'Delete') {
          this.deleteCell();
        }
      });

    /** 图形元素鼠标单击。可能是图形选中或菜单项选中 */
    paper.on('cell:pointerdown', (cellView, evt, x, y) => {
      this.setPermitCache('cell:pointerdown', false);
      this.closeContextMenu();
      const cell = cellView.model;
      this.selectCell(cell);
      this.setPermitCache('cell:pointerdown', true, 300);
    });

    paper.on('type:link', (cellView, evt, x, y) => {
      // console.log('Draw -> type:link');
      const linkType = this.$store.state.ModuleMD.curLinkType;
      const diagram = this.$store.state.ModuleMD.curDiagram;
      if (linkType !== '') {
        if (JointShapeRepository.canCreateLink(linkType, cellView.model.shapeType())) {
          this.beginAddLink();
          const link = JointShapeRepository.createLink(linkType, diagram, cellView.model, new joint.g.Point(x, y));
          link.setDisplayLanguage(this.curDisplayLanguage);
          this.curDiagram.cells.push(link);
          this.curGraph.addCell(link);
          this.curLink = link;
          this.addLinkView(link);
          this.endAddLink();
        }
      }
    });

    paper.on('link:pointerup', (cellView, evt, x, y) => {
      // console.log('Draw -> link:pointerup');
      // 链接线完成，需要设置相应的关系
      const linkType = this.$store.state.ModuleMD.curLinkType;
      if (linkType !== '') {
        this.endAddLink();
      }
    });

    paper.on('link:pointerdown', (cellView, evt, x, y) => {
      // console.log('Draw -> link:pointerdown');
      evt.stopPropagation();

      /** TODO <画线>: 处理方式不好，以后再说 */
      // window.removeEventListener('mousemove', this.handleMove);
    });

    paper.on('class:row:select', (cellView, evt, x, y) => {
      // console.log('Draw -> class:row:select');
      this.setPermitCache('class:row:select', false);
      this.closeContextMenu();
      let designId: string = null;
      if (evt.target.attributes.designId) {
        designId = evt.target.attributes.designId.value;
      }
      this.selectRow(cellView.model, designId);
      this.setPermitCache('class:row:select', true, 300);
    });

    paper.on('class:collapse', (elementView: any, evt: any) => {
      // console.log('Draw -> class:collapse');
      elementView.model.collapse();
      // evt.stopPropagation();
    });

    paper.on('cell:contextmenu', (cellView, evt, x, y) => {
      // console.log('Draw -> class:contextmenu');
      this.setPermitCache('cell:contextmenu', false);
      this.closeContextMenu();
      // evt.stopPropagation();

      this.selectCell(cellView.model);
      if (evt.target.attributes.designId) {
        this.selectRow(cellView.model, evt.target.attributes.designId.value);
      }
      this.openContextMenu(cellView, evt, x, y);
      this.setPermitCache('cell:contextmenu', true, 300);
    });

    /** 右键菜单动作 */
    paper.on('cmenu:action', (cellView, evt, x, y) => {
      // console.log('Draw -> cmenu:action');
      // evt.stopPropagation();
      // console.log('cmenu:action : ' + evt.target.attributes.action.value);
      // console.log(this.$store.state.ModuleMD.curCell);
      this.setPermitCache('cell:contextmenu', false);
      this.closeContextMenu();
      this.setPermitCache('cell:contextmenu', true, 0);
      const action = evt.target.attributes.action.value;
      const curCell = this.$store.state.ModuleMD.curCell as MDShape;
      const typeShape = curCell as MDBaseShape;
      if (typeShape && typeShape.doAction) {
        if (action === 'shape:copy') {
          this.copyCell();
        } else if (action === 'shape:paste') {
          this.pasteCell(this.$store.state.ModuleMD.copyContents);
        } else if (action === 'shape:deleteChild') {
          this.deleteCell();
        } else {
          const element = typeShape.doAction(evt.target.attributes.action.value, this.$store.state.ModuleMD.curMDDesignId);
          if (element != null) {
            this.$store.dispatch('ModuleMD/setElementAction', { element: element, componentDesignId: this.curDiagram.component.designId });
            this.selectRow(typeShape, element.designId); // 选中操作的行，当操作的是一行的时候起效
          }
        }
      }
      if (action === 'component:validate') {
        this.output('开始模型校验');
        const diagram = this.curDiagram;
        const errors = diagram.validate();
        this.$store.dispatch('ModuleMD/setValidationErrorsAction', errors);
        if (errors.length > 0) {
          this.output(`模型校验失败，共有错误数量：${this.$store.state.ModuleMD.validationErrors.length}`);
        } else {
          this.output('模型校验通过');
        }
      } else if ((action as string).indexOf('component:paste') > -1) {
        if (action === 'component:paste') {
          this.pasteCell(this.$store.state.ModuleMD.copyContents, x, y);
        } else if (action === 'component:paste:DTO') {
          const copyContents = new Array<CopyContent>();
          this.$store.state.ModuleMD.copyContents.forEach((item: CopyContent) => {
            const startPoint = (item.curShape as PartShape).shape().startPoint;
            const dtoShape = MDShapeRepository.createNodeShape(this.curDiagram.diagramShape, startPoint.x, startPoint.y, 'BEDTO', false);
            const dto = MDRepository.createDTOFromEntity(this.curDiagram.component as BEComponent, item.curElement as BEEntity, false);
            const jDTOShape = JointShapeRepository.createDTOShape(this.curDiagram, dto, dtoShape, startPoint.x, startPoint.y);
            copyContents.push(new CopyContent(jDTOShape, dto));
          });
          this.pasteCell(copyContents, x, y);
        }
      } else if (action === 'component:saveSVG') {
        this.saveSVG();
      }
      // this.refreshShape(curCell);
    });

    paper.on('blank:contextmenu', (evt, x, y) => {
      // console.log('Draw -> blank:contextmenu');
      this.setPermitCache('blank:contextmenu', false);
      this.closeContextMenu();
      // evt.stopPropagation();
      this.openContextMenu(null, evt, x, y, this.$store.state.ModuleMD.copyContents);
      this.setPermitCache('blank:contextmenu', true, 0);
    });

    paper.on('blank:pointerclick', (evt, x, y) => {
      // console.log('Draw -> blank:pointerclick');
      this.setPermitCache('blank:pointerclick', false);
      this.closeContextMenu();
      this.selectCell(null);
      this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', this.designId);
      this.$store.dispatch('ModuleMD/setCurCellIdAction', '');
      // console.log(IDEContext.instance.getSetting('Editor_View:ComponentLanguage'));
      this.setPermitCache('blank:pointerclick', true, 300);
    });

    paper.on('cell:mouseenter', (cellView, evt, x, y) => {
      // console.log('Draw -> cell:mouseenter');
      const linkType = this.$store.state.ModuleMD.curLinkType;
      if (cellView.model.setLinkType) {
        // this.setPermitCache('cell:mouseenter', false);
        cellView.model.setLinkType(linkType);
        // this.setPermitCache('cell:mouseenter', true, 0);
      }
    });

    paper.on('cell:mouseleave', (cellView, evt, x, y) => {
      // console.log('Draw -> cell:mouseleave');
      if (cellView.model.setLinkType) {
        // this.setPermitCache('cell:mouseleave', false);
        cellView.model.setLinkType('');
        // this.setPermitCache('cell:mouseleave', true, 0);
      }
    });

    paper.on('link:pointerclick', (linkView) => {
      // console.log('Draw -> cell:mouseenter');
      // this.setPermitCache('link:mouseenter', false);
      linkView.showTools();
      // this.setPermitCache('link:mouseenter', true, 0);
    });

    // paper.on('link:mouseleave', (linkView) => {
    //   // console.log('Draw -> cell:mouseleave');
    //   // this.setPermitCache('link:mouseleave', false);
    //   linkView.hideTools();
    //   // this.setPermitCache('link:mouseleave', true, 0);
    // });
  }

  buildGraphEvent(graph: joint.dia.Graph) {
    // console.log('Draw -> buildGraphEvent');
    // TODO ： 获取数据是异步的，所以加了延迟，但是应该是异步返回以后才开始监听
    const debounce = 300;
    graph.on('add', this.cacheGraph);
    graph.on('change:position', _.debounce(this.changeShape, debounce));
    // graph.on('change:markup', _.debounce(this.cacheGraph, debounce));
    graph.on('change:size', _.debounce(this.cacheGraph, debounce));
    graph.on('change:z', _.debounce(this.cacheGraph, debounce));
    graph.on('change:source', _.debounce(this.cacheGraph, debounce));
    graph.on('change:target', _.debounce(this.cacheGraph, debounce));
    graph.on('change:vertices', _.debounce(this.changeShape, debounce));
    graph.on('remove', this.cacheGraph);
    // graph.on('all', (eventName, cell) => {
    //   console.log('event:' + eventName);
    //   // if (eventName === 'change:attrs') {
    //   //   console.log(cell);
    //   // }
    // });
  }

  /** 前端保存SVG文件 */
  saveSVG() {
    // TODO : 多个文档打开的时候，需要找到具体保存的svg标签才能保存

    // 定义文件内容，类型必须为Blob 否则createObjectURL会报错
    const svg = $('div[id="panel' + this.curDiagram.component.designId + '"] svg')[0];
    let svgContent = svg.outerHTML;
    svgContent = svgContent.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');
    svgContent = svgContent.replace('width="100%"', 'width="' + svg.clientWidth + '"');
    svgContent = svgContent.replace('height="100%"', 'height="' + svg.clientHeight + '"');
    const content = new Blob([svgContent]);

    // 生成url对象
    const urlObject = window.URL || window.webkitURL;
    const url = urlObject.createObjectURL(content);
    // 生成<a></a>DOM元素
    const el = document.createElement('a');
    // 链接赋值
    el.href = url;
    el.download = `${this.curDiagram.component.rootNamespace}.svg`;
    // 必须点击否则不会下载
    el.click();
    // 移除链接释放资源
    urlObject.revokeObjectURL(url);
  }

  /** 检测是否操作的是当前的文档，所有的事件相应都应该先做此判断 */
  isCurrentDoc() {
    if (!this.curDiagram || this.curDiagram === null || this.$store.state.ModuleMD.curDiagram === null || this.curDiagram.component.designId !== this.$store.state.ModuleMD.curDiagram.component.designId) {
      return false;
    }
    return true;
  }

  /** Undo & Reduce : 缓存图形：将当前图形保存到堆栈 */
  cacheGraph() {
    if (!this.permitCache) return;
    // console.log('cache graph');
    this.curDiagram.isModified = true;
    const component = this.$store.state.ModuleMD.elements.find((element: any) => element.designId === this.curDiagram.component.designId) as BaseComponent;
    if (component) {
      component.persistenceStatus = EnumPersistenceStatus.Update;
    }
    const json = this.curGraph.toJSON();
    const graghData = GraghData.CreateGraghData(this.curDiagram.isModified, this.curDiagram.component.designId, json);
    // TODO : 压入堆栈需要耗掉很多内存，但是对象本身没有那么大，为什么？
    // TODO 关闭缓存：暂时停用此功能
    // this.stackReduce.push(graghData);
    this.stackRedo.clear();
    // console.log('stackReduce:' + this.stackReduce.size());
  }

  /**
   * @description Undo & Reduce : 还原操作(Ctrl + Z)的执行方法
   */
  reduceGraph() {
    this.setPermitCache('reduceGraph', false);
    // 第一次触发Ctrl+Z
    if (this.stackRedo.size() === 0) {
      const graghData = this.stackReduce.pop(); // 第一次取出的就是当前画布的最新状态
      if (graghData != null) {
        this.stackRedo.push(graghData);
      }
    }
    const reduce = this.stackReduce.pop(); // 上一次的状态，如果存在则还原，不存在则不做处理
    if (reduce != null) {
      this.stackRedo.push(reduce);
      this.restoreGraph(reduce);
    } else {
      this.restoreGraph(this.originalGraphData);
    }
    this.selectCell(null);
    this.setPermitCache('reduceGraph', true, 300);
    // console.log('reduceGraph stackReduce:' + this.stackReduce.size());
    // console.log('reduceGraph stackRedo:' + this.stackRedo.size());
  }

  /**
   * @description Undo & Reduce : 重做操作(Ctrl + Y)的执行方法
   */
  redoGraph() {
    const [redo, current] = [this.stackRedo.pop(), this.curGraph.toJSON()];
    if (redo === null) return;
    this.stackReduce.push(redo);
    if (_.isEqual(redo.graghJSON, current)) {
      const graghData = this.stackRedo.pop();
      if (graghData === null) return;
      this.setPermitCache('redoGraph', false);
      this.stackReduce.push(graghData);
      this.restoreGraph(graghData);
    } else {
      this.setPermitCache('redoGraph', false);
      this.restoreGraph(redo);
    }
    this.setPermitCache('redoGraph', true, 300);
    console.log('reduceGraph stackReduce:' + this.stackReduce.size());
    console.log('reduceGraph stackRedo:' + this.stackRedo.size());
  }

  /** 选中某一个图形 */
  selectCell(cell: any) {
    this.curDiagram.cells.forEach((shape: MDShape) => {
      if (shape.shape().persistenceStatus !== EnumPersistenceStatus.Delete && shape.shape().persistenceStatus !== EnumPersistenceStatus.Remove) {
        if (shape.isSelect()) {
          shape.unSelect();
        }
        if (shape instanceof MDBaseShape) {
          if (shape.selectedElement() !== null) {
            shape.selectRow(null);
          }
        }
        if (shape instanceof RelationshipLink) {
          (shape as any).findView(this.curPaper).hideTools();
        }
      }
    });
    if (this.methodShape !== null && cell !== null && this.methodShape.element().designId === cell.element().designId) {
    } else {
      this.curGraph.removeCells([this.methodShape]);
      this.methodShape = null;
    }

    // 为空代表不选中任何图形元素，比如选中组件
    if (cell != null) {
      const selectedShape = cell as MDBaseShape;
      if (selectedShape.select) {
        const selectedDesignId = selectedShape.select();
        // console.log(selectedShape.isSelect());
        // const temp = this.curDiagram.cells.find((shape: MDShape) => shape.element().designId === selectedShape.element().designId);
        // console.log(temp.isSelect());
        this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', selectedDesignId);
        this.$store.dispatch('ModuleMD/setCurCellAction', cell);
      }
      if (cell instanceof RelationshipLink) {
        cell.findView(this.curPaper).showTools();
      }
    } else {
      this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', '');
      this.$store.dispatch('ModuleMD/setCurCellAction', null);
    }
  }

  selectRow(cell: any, row: string) {
    this.selectCell(cell);
    if (cell.selectRow) {
      cell.selectRow(row);
      const findElement = this.$store.state.ModuleMD.elements.find((element: BaseElement) => element.designId === row);
      if (findElement) {
        if (findElement instanceof InterfaceMethod || findElement instanceof EntityMethod || findElement instanceof ValueObjectMethod) {
          this.methodShape = JointShapeRepository.createMethodShape(this.curDiagram, cell.getRowElement(row), cell.position().x + cell.size().width + 10, cell.position().y);
          this.curGraph.addCell(this.methodShape);
        }
      }
    }
    this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', row);
  }

  /** 填充图表 */
  fillDiagram(diagram: Diagram) {
    if (!diagram.isLock()) {
      const resizeTool = new ResizeTool(this.curPaper);
    }
    this.fillGragh(diagram);
    /** Undo & Reduce */
    this.originalGraphData = GraghData.CreateGraghData(false, this.curDiagram.component.designId, this.curGraph.toJSON());
    this.stackReduce.clear();
    this.stackRedo.clear();
    // this.stackReduce.push(this.originalGraphJSON);
    // console.log('reduceGraph stackReduce:' + this.stackReduce.size());
    this.output(`打开${EnumComponentTypeMD.getItemByValue(this.comType).name}组件：${this.curDiagram.component.name} - ${this.curDiagram.component.displayName}`);
  }

  /** 重新将图表输出到Joint图形 */
  fillGragh(diagram: Diagram) {
    this.curDiagram.setDisplayLanguage(this.curDisplayLanguage);
    this.setPermitCache('fillDiagram', false); // TODO : Undo & Reduce
    this.curGraph.clear();
    const maxWidth = document.getElementById('drawPanel').offsetWidth - 20;
    const maxHeight = document.getElementById('drawPanel').offsetHeight - 30 - 20 - 10; // 20为滚动条的宽度，30是多文档页签的高度，10为上下间距
    let maxCellX = 0;
    let maxCellY = 0;
    diagram.cells.forEach((cell) => {
      if (cell.element().persistenceStatus !== EnumPersistenceStatus.Delete && cell.element().persistenceStatus !== EnumPersistenceStatus.Remove) {
        this.curGraph.addCell(cell);
        cell.fromMD();
        if (cell.position().x > maxCellX) {
          maxCellX = cell.position().x;
        }
        if (cell.position().y > maxCellY) {
          maxCellY = cell.position().y;
        }
        if (cell instanceof BaseLink) {
          if (!this.curDiagram.isLock()) {
            this.addLinkView(cell);
          }
        } else if (cell instanceof MDBaseShape) {
          cell.refresh(); // 根据内容驱动呈现
        }
      }
    });
    this.resizePaper(maxCellX, maxCellY, maxWidth, maxHeight);
    this.curGraph.id = diagram.id;
    this.setPermitCache('fillDiagram', true, 1000);
    this.$store.dispatch('ModuleMD/setCurDiagramAction', diagram);
    this.$store.dispatch('ModuleMD/setDiagramAction', diagram);
  }

  /**
   * Undo & Reduce : 从JSON恢复图形
   * 1、gragh中的元数据拷贝到ModuleMD中
   * 2、gragh的cell数据，同步到Joint图形元数据
   * 3、Joint图形元数据同步到Diagram中的图形
   * 4、将图形元数据和元数据重新设置到gragh的cell中
   */
  restoreGraph(graghData: GraghData) {
    this.curGraph.fromJSON(graghData.graghJSON);
    this.curDiagram.isModified = graghData.isModified;
    const handledDesignIds = new Array<string>();
    const gragpCells = this.curGraph.getCells();
    // Gragh和Diagram都有，将Gragh同步到Diagram
    gragpCells.forEach((cell) => {
      const graghCell = cell as unknown as MDShape;
      if (graghCell.element) { // ResizeTool不能做如下处理
        const findCell = this.curDiagram.cells.find((item: MDBaseShape) => item.element().designId === graghCell.element().designId);
        graghCell.toMD(); // 将JOINT图形的数据同步到图形元数据
        JointShapeRepository.copyFullShape(this.curDiagram, graghCell, findCell);
        if (graghCell instanceof RelationshipLink) {
          this.addLinkView(graghCell);
        }
        handledDesignIds.push(graghCell.element().designId);
      }
    });
    // Gragh没有，Diagram有，需要将Diagram中的元素：Create状态的删除，其他状态则置为删除状态
    const deleteCells = new Array<any>();
    this.curDiagram.cells.forEach((cell: any) => {
      if (handledDesignIds.indexOf(cell.element().designId) < 0) {
        if (cell.element().persistenceStatus === EnumPersistenceStatus.Create) {
          deleteCells.push(cell);
        } else {
          cell.element().persistenceStatus = EnumPersistenceStatus.Delete;
        }
      }
    });
    deleteCells.forEach(item => {
      this.curDiagram.deleteCell(item);
    });
    this.fillGragh(this.curDiagram);
  }

  changeShape(cell: any, newPosition: any, opt: any) {
    if (cell.toMD) {
      cell.toMD();
      const size = this.curPaper.getComputedSize();
      this.resizePaper(Number(newPosition.x), Number(newPosition.y), size.width, size.height);
      this.cacheGraph();
    }
  }

  /**
   * 根据当前Paper的尺寸，以及新的元素坐标，动态扩展Paper大小，横纵坐标都加300.
   * @param cellX 元素的左上角X坐标
   * @param cellY 元素的左上角Y坐标
   * @param paperWidth 画布的宽度
   * @param paperHeight 画布的高度
   */
  resizePaper(cellX: number, cellY: number, paperWidth: number, paperHeight: number) {
    let maxHeight = paperHeight;
    let maxWidth = paperWidth;
    if (cellX + 300 > maxWidth) {
      maxWidth = cellX + 300;
    }
    if (cellY + 300 > paperHeight) {
      maxHeight = cellY + 300;
    }
    this.curPaper.fitToContent({ minWidth: maxWidth, minHeight: maxHeight });
  }

  // 删除连线：由线上删除按钮触发
  deleteLink(evt: dia.Event, linkView: dia.LinkView) {
    const linkShape = linkView.model as unknown as MDShape;
    const element = linkShape.element();
    this.$store.dispatch('ModuleMD/setCurCellAction', linkView.model);
    this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', element.designId);
    this.deleteCell();
  }

  /** 删除选中的图形：图形、线条等 */
  deleteCell() {
    const cell = this.$store.state.ModuleMD.curCell as MDShape;
    if (!cell) {
      this.$message({ type: 'info', message: '请选择要删除的图形或线!' });
      return;
    }
    const isCell = cell.element().designId === this.$store.state.ModuleMD.curMDDesignId;
    let message = `此操作将永久删除元素 [${cell.element().displayName}], 是否继续?`;
    if (!isCell) {
      message = `此操作将永久删除元素 [${cell.element().displayName}] 的子元素, 是否继续?`;
    }
    this.$confirm(message, '删除提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      // 1.图形从gragh中删除
      // 2.元数据修改状态设置为delete
      // 3.图形元数据修改状态设置为delete
      // 4.记录undo、redo
      // 选中的是图形或线：删除元数据及图形元数据
      const shape: ShapeElement = cell.shape();
      if (isCell) {
        const element = cell.element();
        const shape: ShapeElement = cell.shape();
        if (element.persistenceStatus === EnumPersistenceStatus.Create) {
          this.curDiagram.deleteCell(cell);
        } else {
          if (element instanceof MenuSet) { // 删除菜单集的时候，设置为不启用
            element.isValid = false;
          }
          element.persistenceStatus = EnumPersistenceStatus.Delete;
          shape.persistenceStatus = EnumPersistenceStatus.Delete;
        }
        if (element instanceof Aggregation) {
          // 如果聚合的源和目标为相同实体，删除以后将实体设置为单实体（只能有一条自关联聚合线）
          if (element.sourceEntity_ID === element.targetEntity_ID) {
            element.sourceEntity.entityStructureType = EnumEntityStructureType.SingleEntity;
          }
        }
        const cells = new Array<dia.Cell>();
        cells.push(cell as unknown as dia.Cell);
        // 删除图形相关的线
        this.curDiagram.cells.forEach(diagramCell => {
          if (diagramCell instanceof RelationshipLink) {
            let isRemoved = false;
            const sourceElement = diagramCell.getSourceElement();
            const targetElement = diagramCell.getTargetElement();
            if (sourceElement instanceof MDBaseShape && sourceElement.element().id === cell.element().id) {
              isRemoved = true;
            } else if (targetElement instanceof MDBaseShape && targetElement.element().id === cell.element().id) {
              isRemoved = true;
            }
            if (isRemoved) {
              const diagramCellElement = diagramCell.element();
              const diagramCellShape = diagramCell.shape();
              if (diagramCellElement.persistenceStatus === EnumPersistenceStatus.Create) {
                this.curDiagram.deleteCell(diagramCell);
              } else {
                diagramCellElement.persistenceStatus = EnumPersistenceStatus.Delete;
                diagramCellShape.persistenceStatus = EnumPersistenceStatus.Delete;
              }
              cells.push(diagramCell);
            }
          }
        });
        this.curGraph.removeCells(cells);
        this.$store.dispatch('ModuleMD/setDiagramAction', this.curDiagram);
      } else {
        // 选中的是图形内的行：删除元数据，不影响图形
        if (cell instanceof PartShape) {
          const deleteElement = cell.doAction('shape:deleteChild', this.$store.state.ModuleMD.curMDDesignId);
          if (deleteElement !== null) {
            if (deleteElement.persistenceStatus === EnumPersistenceStatus.Delete) {
              // 如果状态是Delete，则是逻辑删除，要发送到服务端
              this.$store.dispatch('ModuleMD/setElementAction', { element: deleteElement, componentDesignId: this.curDiagram.component.designId });
            } else {
              // 否则，是新增的元素，直接从客户端移除
              this.$store.dispatch('ModuleMD/removeElementAction', { element: deleteElement, componentDesignId: this.curDiagram.component.designId });
            }
          }
        }
      }
      this.selectCell(null);
      this.$message({ type: 'success', message: '删除成功!' });
    }).catch(() => {
      // 取消删除
    });
  }

  saveDiagram(diagram: Diagram) {
    if (diagram.isModified) {
      // 将component的信息从elements中复制
      const component = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === diagram.component.designId);
      if (component) {
        diagram.component.copyFrom(component, false);
      }
      const deleteDesignIds = new Array<string>();
      JointShapeRepository.saveComponentAsync(diagram, deleteDesignIds)
        .then((response) => {
          diagram.saved();
          const component = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === diagram.component.designId);
          if (component) {
            diagram.component.persistenceStatus = EnumPersistenceStatus.None;
            component.persistenceStatus = EnumPersistenceStatus.None;
            deleteDesignIds.forEach(designId => {
              const deleteElement = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === designId) as BaseElement;
              if (deleteElement) {
                this.$store.dispatch('ModuleMD/removeElementAction', { element: deleteElement, componentDesignId: component.designId });
              }
            });
          }
          const message = `组件 [${this.curDiagram?.component?.displayName}] 模型保存成功。`;
          this.output(message);
          this.$message({ type: 'success', message: message });
        })
        .catch((exp) => {
          const message = `组件 [${this.curDiagram?.component?.displayName}] 模型保存失败，失败原因：${exp}。`;
          this.output(message);
          this.$message({ type: 'error', message: message });
        });
    }
  }

  /** 找到当前Diagram中选中的图形 */
  findSelectedShape(): Array<MDShape> {
    const shapes = new Array<MDShape>();
    this.curDiagram.cells.forEach((shape: MDShape) => {
      if (shape.isSelect()) {
        shapes.push(shape);
      }
    });
    return shapes;
  }

  /**
   * 复制选中的图形：图形等，线条不能独立复制（线条复制的前提是源和目标复制）
   * 1、线条不能独立复制《TODO：暂时未考虑》
   * 2、复制多个图形，包括线条：此时忽略图形内的选中行
   * 3、单一图形内部多行被选中，多行复制
   */
  copyCell() {
    const copyContents = new Array<CopyContent>();
    const shapes = this.findSelectedShape();
    if (shapes.length === 1) {
      const shape = shapes[0];
      if (shape instanceof PartShape && shape.selectedElement() !== null) {
        // 一个图形中的行复制
        copyContents.push(new CopyContent(shape, shape.selectedElement()));
      } else {
        copyContents.push(new CopyContent(shape, shape.element()));
      }
    } else {
      shapes.forEach(shape => copyContents.push(new CopyContent(shape, shape.element())));
    }
    this.$store.dispatch('ModuleMD/setCopyContentsAction', copyContents);
  }

  /**
   * 粘贴复制的图形：图形、线条等
   * 1、图形：包含其下的所有属性等
   * 2、图形内的子元素，比如：属性
   * 3、线条
   * @param x 左上角横坐标，不传则使用源图形的x
   * @param y 左上角纵坐标，不传则使用源图形的y
   */
  pasteCell(copyContents: Array<CopyContent>, x?: number, y?: number) {
    const newElements = new Array<BaseElement>();
    for (let i = 0; i < copyContents.length; i++) {
      const copyContent = copyContents[i] as CopyContent;
      // 复制单行
      if (copyContent.curElement.designId !== copyContent.curShape.element().designId) {
        const shapes = this.findSelectedShape();
        if (shapes.length === 1 && shapes[0] instanceof PartShape) {
          const shape = shapes[0] as PartShape;
          shape.addChildClone(copyContent.curElement, newElements);
          this.refreshShape(shape);
        }
      } else {
        // 复制图形
        const jShape = copyContent.curShape.cloneShape(this.curDiagram, newElements);
        if (x && y && jShape instanceof PartShape) {
          jShape.shape().startPoint = new Double2D(x, y);
          jShape.position(x, y);
        }
        this.curGraph.addCell(jShape as unknown as dia.Cell);
        this.selectCell(jShape);
        // copyContent.curShape.unSelect();
      }
    }
    newElements.forEach(newElement => this.$store.dispatch('ModuleMD/setElementAction', { element: newElement, componentDesignId: this.curDiagram.component.designId }));
  }

  /** 设置是否记录变化的堆栈 */
  setPermitCache(name: string, permit: boolean, timeout?: number) {
    if (timeout && timeout > 0) {
      // console.log('setPermitCache:' + permit + ' begin-------' + name);
      setTimeout(() => {
        this.permitCache = permit;
        // console.log('setPermitCache:' + permit + ' action-------' + name);
      }, timeout);
    } else {
      this.permitCache = permit;
      // console.log('setPermitCache:' + permit + '-------' + name);
    }
  }

  output(message: string) {
    this.$store.dispatch('ModuleMD/setOutputMessagesAction', message);
  }
}

Object.assign(joint.shapes, {
  mst: {
    JointProductAPPShape,
    JointCommentShape,
    PartShape,
    RectShape,
    MDBaseShape,
    BaseShapeView,
    JointBusinessLogicShape,
    JointEntityShape,
    JointConfigGroupShape,
    JointConstantShape,
    JointReferenceEntityShape,
    JointDistributedTransactionShape,
    JointDTOShape,
    JointEnumShape,
    JointExternalServiceShape,
    JointInterfaceShape,
    JointMenuSetShape,
    JointServiceShape,
    JointValueObjectShape,
    BaseLink,
    RelationshipLink,
    BaseLinkView,
    JointAggregationLink,
    JointAssociationLink,
    JointCompositionLink,
    JointCrossLink,
    JointDependencyAssociationLink,
    JointGenerationLink,
    JointImplementLink,
    JointMenuContainLink,
    ContextMenu
  }
});

